'use strict';

/*
 * Sets Focus on a certain field when a page is shown
 */
angular.module('posApp').directive('onFocus', ($log) => ({
  restrict: 'A',

  link: function (scope, elm, attrs) {
    elm.bind('focus', () => {
      scope.$parent.currentFocus = attrs.ngModel;
      $log.log(scope.$parent.currentFocus);
    });
  },
}));
